module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/price-set-4fe9517b752d19c55d63c8fa886cf23c.svg";